var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestQuotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,2 L5,2 C3.34314575,2 2,3.34314575 2,5 L2,21 L2.00598327,21.1136309 C2.09281919,21.9276677 3.1045317,22.3096819 3.70710678,21.7071068 L7.414,18 L19,18 C20.6568542,18 22,16.6568542 22,15 L22,5 C22,3.34314575 20.6568542,2 19,2 Z M5,4 L19,4 C19.5522847,4 20,4.44771525 20,5 L20,15 C20,15.5522847 19.5522847,16 19,16 L7,16 L6.86855602,16.0086724 C6.65185492,16.0374017 6.44917353,16.1366129 6.29289322,16.2928932 L4,18.585 L4,5 C4,4.44771525 4.44771525,4 5,4 Z",
    id: "path-comment"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/angebotsanfrage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-comment",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-comment"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#path-comment"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-comment)",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\u20AC",
    fontFamily: ".AppleSystemUIFont",
    fontSize: 12,
    fontWeight: "normal",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.22070312,
    y: 14
  }, "\u20AC")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestQuotation);
export default __webpack_public_path__ + "static/media/request-quotation.e5548d00251df08854b12bdfa02bc253.svg";
export { ForwardRef as ReactComponent };